/* eslint-disable no-template-curly-in-string */
import { FormsValidationLocalization } from "../types/graphql/generated";

export const genericErrorMsgEnglish = "Something went wrong. Please try again.";

const NO_MATCH =
  "Oops, it looks like your email and password combination don't match!";

export const SignUpErrorMessages: { [key: string]: string } = {
  not_found: NO_MATCH,
  invalid_password: NO_MATCH,
  account_locked: "Your account has been locked.",
  unverified_email: "Please enter a valid email address.",
};

export const validationErrorsEnglish: FormsValidationLocalization = {
  dayRequiredErrorText: "Please select a day",
  emailRequiredErrorText: "Your email address is required",
  fieldRequiredErrorText: "This field cannot be left blank",
  invalidDateErrorText: "Please enter a valid date.",
  invalidPasswordErrorText: "Invalid password",
  invalidPhoneErrorText: "Invalid phone number",
  monthRequiredErrorText: "Please select a month",
  newPasswordRequiredErrorText:
    "Please enter a new password to use for your account",
  passwordRequiredErrorText: "Your password is required",
  requiredErrorText: "Required",
  signupPasswordRequiredErrorText:
    "Please enter a password to use for your account",
  wrongEmailErrorText: "Email address is not valid",
  yearRequiredErrorText: "Please select a year",
  invalidTaxIdErrorText: "Invalid Tax ID",
  invalidTaxIdLengthErrorText: "Must be exactly 10 digits",
  companyRequiredWithTaxIdErrorText:
    "${companyLabel} is required with ${taxIdLabel}",
  taxIdRequiredWithCompanyErrorText:
    "${taxIdLabel} is required with ${companyLabel}",
};

export const sentryIgnoreErrorsList = [
  // Random plugins/extensions
  "top.GLOBALS",
  "ResizeObserver loop limit exceeded",
  "Can't find variable: instantSearchSDKJSBridgeClearHighlight",
  "Can't find variable: _AutofillCallbackHandler",
  "Failed to fetch",
  "Load failed",
  "The network connection was lost.",
  "TypeError: Failed to fetch",
  "TypeError: NetworkError when attempting to fetch resource.",
  "TypeError: Load failed",
  "TypeError: The network connection was lost.",
  "TypeError: cancelled",
  "cancelled",
  // Request header fields too large (usually due to many tracking cookies)
  /Response not successful: Received status code 431/,
  // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
  "originalCreateNotification",
  "canvas.contentDocument",
  "MyApp_RemoveAllHighlights",
  "http://tt.epicplay.com",
  "Can't find variable: ZiteReader",
  "jigsaw is not defined",
  "ComboSearch is not defined",
  "http://loading.retry.widdit.com/",
  "atomicFindClose",
  // Facebook borked
  "fb_xd_fragment",
  // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
  // reduce this. (thanks @acdha)
  // See http://stackoverflow.com/questions/4113268
  "bmi_SafeAddOnload",
  "EBCallBackMessageReceived",
  // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
  "conduitPage",
  "Network request failed",
  "Error: Document is ready and element #paypal-button does not exist",
  /Error: Request to post \/smart\/api\/payment(.*)$/,
  /Event `CustomEvent` \(type=unhandledrejection\) captured as promise rejection/,
  /Error: Invalid call to runtime\.sendMessage\(\)\. Tab not found\./,
  /Invariant: attempted to hard navigate to the same URL/,
];

export const sentryDenyUrlsList = [
  // Facebook flakiness
  /graph\.facebook\.com/i,
  // Facebook blocked
  /connect\.facebook\.net\/en_US\/all\.js/i,
  // Chrome extensions
  /extensions\//i,
  /^chrome:\/\//i,
  // Other plugins
  /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
  /webappstoolbarba\.texthelp\.com\//i,
  /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
  // Browser extensions
  /^chrome-extension:\/\//i,
  /^moz-extension:\/\//i,
  /^safari-extension:\/\//i,
];
